export const roles = {
  Member: 1,
  Admin: 2,
  AdminPlus: 3
};
